import {Component, Inject, inject, Input, OnInit} from "@angular/core";
import {Resource} from "../../../models/resource";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ResourceService} from "../../../services/resource.service";
import {locale as polish} from './../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {ConfirmOpenSlotModalComponent} from "../confirmOpenSlotModal/confirmOpenSlotModal.component";
import {TrainingService} from "../../../services/training.service";
import {Training} from "../../../models/training";
import {TrainingItems} from "../../../models/trainingItems";
import {first} from "rxjs/operators";
import {AlertService} from "../../../services";


@Component({
    selector: 'resource-online-details-details-modal-component',
    templateUrl: './resourceOnlineDetailsModal.component.html',
})
export class ResourceOnlineDetailsModalComponent {
    public resource: Resource;
    public modules: any[];
    public loadingDetails: boolean = true;
    public serviceDevice: any = {};
    public trainings: Training[] = [];
    public trainingsLoading: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<ResourceOnlineDetailsModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private resourceService: ResourceService,
        private translationLoader: FuseTranslationLoaderService,
        public dialog: MatDialog,
        private trainingService: TrainingService,
        private alertService: AlertService
    ) {
        this.resource = _data.resource;
        this.translationLoader.loadTranslations(polish);

        this.resourceService.getServiceDeviceById(this.resource.id).subscribe(data => {
            if (data.heartbeatAt) {
                let heartbeatAt = new Date(data.heartbeatAt);
                let currentDate = new Date();
                let c = currentDate.getTime() - (2 * 60000); //-2 minut

                if (c < heartbeatAt.getTime()) {
                    data.online = true;
                }
            }

            if (!data.workout) {
                data.workout = false;
            }

            this.serviceDevice = data;
        });

        this.resourceService.getServiceDeviceModulesById(this.resource.id).subscribe(data => {
            this.modules = data.items;
            this.loadingDetails = false;
        }, err => {
            this.modules = [];
            this.loadingDetails = false;
        });

        // Load trainings for this resource
        this.loadTrainings();
    }

    loadTrainings(): void {
        this.trainingsLoading = true;

        this.trainingService.getTrainings({
            resourceId: this.resource.id,
            limit: 20,
            sortCol: 'createdAt',
            sortDir: 'desc'
        }).pipe(first()).subscribe(
            (res: TrainingItems) => {
                this.trainings = res.items;
                this.trainingsLoading = false;
            },
            error => {
                this.alertService.error(error);
                this.trainingsLoading = false;
            }
        );
    }

    openSlot(id: string, slotNumber: string) {
        const dialogRef = this.dialog.open(ConfirmOpenSlotModalComponent, {
            width: '400px',
            data: {
                slotNumber: slotNumber
            },
            position: {
                top: '40px',
            },
            panelClass: 'custom-dialog-container'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result==='confirm-open') {
                console.log(slotNumber);
                this.resourceService.openSlot(id, slotNumber).subscribe(res => {

                });
            }
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
